const PREFIX = 'Monitor/';

export const FETCH_15MIN_REQUESTED = `${PREFIX}FETCH_15MIN_REQUESTED`;
export const FETCH_15MIN_SUCCEEDED = `${PREFIX}FETCH_15MIN_SUCCEEDED`;
export const FETCH_15MIN_FAILED = `${PREFIX}FETCH_15MIN_FAILED`;

export const FETCH_1HOUR_REQUESTED = `${PREFIX}FETCH_1HOUR_REQUESTED`;
export const FETCH_1HOUR_SUCCEEDED = `${PREFIX}FETCH_1HOUR_SUCCEEDED`;
export const FETCH_1HOUR_FAILED = `${PREFIX}FETCH_1HOUR_FAILED`;

export const FETCH_6HOUR_REQUESTED = `${PREFIX}FETCH_6HOUR_REQUESTED`;
export const FETCH_6HOUR_SUCCEEDED = `${PREFIX}FETCH_6HOUR_SUCCEEDED`;
export const FETCH_6HOUR_FAILED = `${PREFIX}FETCH_6HOUR_FAILED`;

/**Litter status codes  */
export const LITTER_STATUS = {
    '1': 'CREATED',
    '10': 'PREDICT_TAG',
    '20': 'CREATE_THUMBNAIL',
    '30': 'CREATE_SUMMARY',
    '40': 'ASSOCIATE_CHALLENGES',
    '1000': 'SINGLE SUCCESS',
    '2000': 'MULTI SUCCESS',

    '1100': 'SINGLE_ERROR PREDICT_TAG',
    '1200': 'SINGLE_ERROR CREATE_THUMBNAIL',
    '1300': 'SINGLE_ERROR CREATE_SUMMARY',
    '1400': 'SINGLE_ERROR ASSOCIATE_CHALLENGES',
    '1500': 'SINGLE_ERROR ASSOCIATE_ACTIVITY',

    '2100': 'MULTI_ERROR PREDICT_TAG',
    '2101': 'MULTI_ERROR PREDICT_TAG_IOD',
    '2102': 'MULTI_ERROR PREDICT_TAG_BRAND',
    '2103': 'MULTI_ERROR PREDICT_TAG_MATERIAL',
    '2104': 'MULTI_ERROR PREDICT_TAG_OBJECT',
    '2200': 'MULTI_ERROR CREATE_THUMBNAIL',
    '2300': 'MULTI_ERROR CREATE_SUMMARY',
    '2400': 'MULTI_ERROR ASSOCIATE_CHALLENGES',
    '2500': 'MULTI_ERROR ASSOCIATE_ACTIVITY',
};
